import React from "react";
import PropTypes from "prop-types";
import QuantityInput from "./Partials/QuantityInput";
import { updateLineItem } from "../../store/actions";
import { useDispatch } from "react-redux";
import { formatMoney } from "../../utils/helpers";

const LineItem = ({ lineItem }) => {
  const dispatch = useDispatch();

  const { id, quantity, merchandise, cost } = lineItem;

  const { title: variantTitle, price, product } = merchandise;

  const productImage = product?.images?.edges?.[0]?.node;

  const displayTitle = product?.title || variantTitle;

  const imageUrl =
    productImage?.url ||
    `${process.env.IMAGES_BASE_URL}/static/vendors/images/general/no_image.png`;

  const imageAlt = productImage?.altText || displayTitle;

  return (
    <div className="line-item flex-column flex-sm-row">
      <div className="line-item__image">
        <img src={imageUrl} alt={imageAlt} />
      </div>
      <div className="line-item__content">
        <div className="line-item__content__product-details">
          <div className="line-item__content__product-details__title">{displayTitle}</div>
          <div className="line-item__content__product-details__price">
            {formatMoney(price.amount, price.currencyCode)}
          </div>
        </div>

        <div className="line-item__content__quantity">
          <QuantityInput lineItem={lineItem} />
          <div className="line-item__content__quantity__remove">
            <img
              src={`${process.env.IMAGES_BASE_URL}/static/vendors/images/icons/delete-major.svg`}
              alt="Remove item"
              onClick={() => dispatch(updateLineItem({ id, quantity: 0 }))}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

LineItem.propTypes = {
  lineItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    merchandise: PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      price: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currencyCode: PropTypes.string.isRequired,
      }).isRequired,
      product: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        handle: PropTypes.string.isRequired,
        images: PropTypes.shape({
          edges: PropTypes.arrayOf(
            PropTypes.shape({
              node: PropTypes.shape({
                url: PropTypes.string.isRequired,
                altText: PropTypes.string,
              }),
            })
          ),
        }),
      }).isRequired,
    }).isRequired,
    cost: PropTypes.shape({
      totalAmount: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currencyCode: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default LineItem;
